import React from 'react';
import styled from 'styled-components';

import { Browser } from '../utils/browser';
import { theme } from '../utils/theme';
import { useChromecast } from './ChromecastProvider';

export function ChromecastButton() {
  const { initializeCastApi } = useChromecast();

  function chromecastButtonVisible() {
    if (!window.cast) return false;

    if (Browser.os.name === 'Android') {
      return false;
    }

    const castState = cast.framework.CastContext.getInstance().getCastState();

    if (castState !== cast.framework.CastState.NO_DEVICES_AVAILABLE) {
      return true;
    }

    // Attempt to initialize the Cast API if not already done.
    // If there're devices available, the button will be shown after a short delay.
    initializeCastApi?.();

    return false;
  }

  return chromecastButtonVisible() ? (
    <ChromecastControl dangerouslySetInnerHTML={{ __html: '<google-cast-launcher></google-cast-launcher>' }} />
  ) : null;
}

const ChromecastControl = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.2s ease-out;
  margin-bottom: 8px;

  &:hover {
    opacity: 1;
  }

  @media ${theme.mobileMediaQuery} {
    width: 18px;
    height: 18px;
    top: 24px;
    right: 24px;
  }

  google-cast-launcher {
    width: 100%;
    height: 100%;
  }
`;
